import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import styles from '../../css/components/ipp/ippButton.css';
import { THIRD_PARTY_ACCEPTANCE_URL_PARAM } from '../../helpers/cookie-overlay';

function IppButton({
	providerName,
	baseProviderUrl,
	isSkippingNickname = false,
	cookieNotificationValue = '',
	onLinkClick,
	parentForm,
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const gameId = onelpsParams.gameId;
	const pageType = onelpsParams.pageType;

	const getFullHref = () => {
		const gameId = onelpsParams.gameId;
		const marketId = onelpsParams.marketId;
		const queryString = window.location.search;

		const additionalQueryParams =
			'&market=' + marketId +
			'&skip_nickname=' + (isSkippingNickname ? '1' : '0') +
			'&lp_campaign_id=' + onelpsParams.campaignId +
			'&lp_design_id=' + onelpsParams.landingPageId +
			'&' + THIRD_PARTY_ACCEPTANCE_URL_PARAM + '=' + cookieNotificationValue;

		if (queryString) {
			return baseProviderUrl + queryString +
			'&game=' + gameId +
			additionalQueryParams;
		} else {
			return baseProviderUrl +
			'?game=' + gameId +
			additionalQueryParams;
		}
	};

	const useLargeIpp = (gameId === 'foe' && pageType === 'ingame') || onelpsParams.form?.ippPosition === 'aboveTerms';

	return (
		<>
			{useLargeIpp ? (
				<button
					type="button"
					className={`${styles['ippLarge']} ${styles[providerName]}`}
					onClick={(e) => onLinkClick(e, getFullHref())}
					id={`page_${parentForm === 'loginForm' ? 'login' : 'registration'}_n/a_ipp_${providerName}`}
				>
					{providerName}
				</button>
			) : (
				<a
					href={getFullHref()}
					className={`${styles.ipp} ${styles[providerName]} ${styles[onelpsParams.gameId]} ${pageType === 'ingame' ? styles.ingame : ''}`}
					title={providerName}
					onClick={(e) => onLinkClick(e, getFullHref())}
					target="_blank"
					id={`page_${parentForm === 'loginForm' ? 'login' : 'registration'}_n/a_ipp_${providerName}`}
					rel="noreferrer"
				>
					{providerName}
				</a>

			)}
		</>
	);
}

export default IppButton;

IppButton.propTypes = {
	providerName: PropTypes.string.isRequired,
	baseProviderUrl: PropTypes.string.isRequired,
	isSkippingNickname: PropTypes.bool,
	cookieNotificationValue: PropTypes.string,
	onLinkClick: PropTypes.func.isRequired,
	parentForm: PropTypes.string,
};
